import React from "react";
import classNames from "classnames";
export const FormGroup = (props) => {
    return (React.createElement("div", { className: classNames("form-group", props.cssWrapper) },
        React.createElement("label", { className: "form-label", htmlFor: props.htmlFor },
            props.label && React.createElement("span", { className: "text" }, props.label),
            props.optional && React.createElement("span", { className: "optional" }, "(nepovinn\u00E9)"),
            props.error && React.createElement("span", { className: "inline-error" }, props.error)),
        props.children));
};
